// Unauthorized.js
import React from "react";
import { ConfigProvider, notification } from "antd";
import Header from "../component/menu/Header";
import SideMenu from "../component/menu/SideMenu";
import { constants } from "../constant/constants";
import CustomLoader from "../component/menu/CustomLoader";

const Unauthorized = () => {
  const [api, contextHolder] = notification.useNotification();

  return (
    <div className="flex flex-col bg-[#e5e7eb]">
      {contextHolder}
      <CustomLoader />
      <Header title={""} menu={""} />
      <div className="flex flex-row bg-prewhite">
        <SideMenu title={`McDonalds Food Chain`} menu={""} />
        <div className="flex flex-row p-[24px] w-full mt-[80px] ml-[72px]">
          <div className="flex flex-col w-full">
            <div className="flex items-center justify-center min-h-screen">
              <div className="text-center bg-white shadow-lg rounded-lg p-8 md:p-12">
                <h1 className="text-6xl font-bold text-red-500">403</h1>
                <h2 className="text-2xl md:text-3xl font-semibold mt-4 text-gray-800">
                  Access Denied
                </h2>
                <p className="mt-4 text-gray-600">
                  You don't have the necessary permissions to access this page.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
